import { core } from '@tock/coretypes';
import { requiresEmailConfirmation } from '@tock/shared/utils/patron';
import Anchor from 'components/Anchor';
import Banner from 'components/banner/Banner';
import BannerAction from 'components/banner/BannerAction';
import BannerParagraph from 'components/banner/BannerParagraph';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  onResendConfirmation(): void;
  patron: core.Patron;
  getPatronStatus(): void;
}

export default class EmailConfirmationBanner extends BaseComponent<Props> {
  handleClick() {
    this.props.onResendConfirmation();
  }

  render() {
    const { patron } = this.props;

    if (!requiresEmailConfirmation(patron)) {
      return <div />;
    }

    return (
      <Anchor onClick={this.props.getPatronStatus}>
        <Banner heading="Please confirm your email" type="alert">
          <BannerParagraph>Check your inbox for your account activation email.</BannerParagraph>

          <BannerAction analyticsEventLabel="Resend activation email" onClick={this.handleClick}>
            Re-send the activation email
          </BannerAction>
        </Banner>
      </Anchor>
    );
  }
}
